import React from 'react';
import { AxiosResponse } from "axios";
import FileSaver from "file-saver";

export default function useFileSaver () {
    const save = React.useCallback((response: AxiosResponse<string | Blob>, defaultFileName: string) => {
        const sugestedFileName = response.headers["x-suggested-filename"];
        const fileName = sugestedFileName === undefined ? defaultFileName : sugestedFileName;
        FileSaver.saveAs(response.data, fileName);
    }, []);

    return React.useMemo(() => ({
        save
    }), [save]);
}